<template>
  <div class="invoice" >
    <swiper :options="swiperOption" ref="mySwiper" v-if="!previewShow">
      <swiper-slide v-for="(item,i) in invoiceList" :key="i">
        <div class="img-wrp">
          <InvoiceCanvas v-if="item.id" @click.native.stop="onShowCanvas(i)" :invoiceData="item" ref="invoiceCanvasRef" class="invoicePic"></InvoiceCanvas>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination" v-show="isPagination"></div>
    </swiper>
    <ImagePreview @onClose="onPreviewClose" :visible="previewShow" :img="img" />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import InvoiceCanvas from '../InvoiceCanvas'
import ImagePreview from '@components/ImagePreview'
export default {
  components: {
    swiper,
    swiperSlide,
    ImagePreview,
    InvoiceCanvas
  },
  props: {
    invoiceList: {
      type: Array
    }
  },
  data () {
    return {
      img: '',
      previewShow: false,
      swiperOption: {
        // 循环
        loop: true,
        // 滑动速度
        speed: 500,
        // delay:1000
        pagination: {
          el: '.swiper-pagination',
          // type: 'fraction'
          dynamicBullets: true
        }
      },
      isPagination: false
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  activated () {},
  updated () {},
  methods: {
    onShowCanvas (index) {
      let src = this.$refs.invoiceCanvasRef[index].$refs.imgRef.children[0].src
      this.previewShow = true
      this.img = src
    },
    onPreviewClose () {
      this.previewShow = false
    }
  }
}
</script>
<style scoped lang='less'>
.invoice{
  width: 693px;
  height: 446px;
  .img-wrp{
    padding-bottom: 50px;
    img {
      height: auto;
      width: 100%;
    }
    .invoicePic {
      height: auto;
      width: 100%;
    }
  }
}
</style>
